import * as api from '../api.js';

export function formatProviderSpecialties(
  specialties: api.ProviderProfile.Profile['specialties'],
) {
  return specialties
    ?.map(
      (specialty: api.Encounter.Specialty) =>
        api.Common.SpecialtyMap[specialty],
    )
    .sort()
    .join(', ');
}
